import { useEffect } from 'react';

const useScrollToTop = (): void => {
  // scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export default useScrollToTop;
